import request from '@/utils/request'

const PRELIMINARY_CLASSIC = '/csbd'


// 是否完成每日挑战
export function getFinishEveryTiku(params) {
	return request({
		url: PRELIMINARY_CLASSIC + '/finish_every_tiku',
		method: 'get',
		params
	})
}

// 获取用户做题信息
export function getMyRank(params) {
	return request({
		url: PRELIMINARY_CLASSIC + '/my_rank',
		method: 'get',
		params
	})
}

// 自由练习-获取题库列表
export function getTikuList(params) {
	return request({
		url: PRELIMINARY_CLASSIC + '/tiku_list',
		method: 'get',
		params
	})
}

// 自由练习-获取题目列表
export function getTikuProblemList(params) {
	return request({
		url: PRELIMINARY_CLASSIC + '/tiku_problem_list',
		method: 'get',
		params
	})
}

// 自由练习-提交答案
export function getSubmitTiku(data) {
	return request({
		url: PRELIMINARY_CLASSIC + '/submit_tiku',
		method: 'post',
		data
	})
}

// 回看-加入错题本
export function addUserCollect(data) {
	return request({
		url: PRELIMINARY_CLASSIC + '/add_user_collect',
		method: 'post',
		data
	})
}
// 回看-移除错题本
export function removeUserCollect(data) {
	return request({
		url: PRELIMINARY_CLASSIC + '/remove_user_collect',
		method: 'post',
		data
	})
}



// 获取错题本
export function getUserCollectTikuProblemList(params) {
	return request({
		url: PRELIMINARY_CLASSIC + '/user_collect_tiku_problem_list',
		method: 'get',
		params
	})
}

// 提交错题本
export function submitUserCollectTiku(data) {
	return request({
		url: PRELIMINARY_CLASSIC + '/submit_user_collect_tiku',
		method: 'post',
		data
	})
}



// 获取每日挑战题目
export function getEveryTikuProblemList(params) {
	return request({
		url: PRELIMINARY_CLASSIC + '/every_tiku_problem_list',
		method: 'get',
		params
	})
}

// 每日挑战提交
export function submitEveryTiku(data) {
	return request({
		url: PRELIMINARY_CLASSIC + '/submit_every_tiku',
		method: 'post',
		data
	})
}